const payloadCustomer = state => state.payloadDetails.customer;
const payloadBillingAddress = state => state.payloadDetails.billingAddress;
const payloadOrderToken = state => state.payloadDetails.orderToken;
const payloadUuid = state => state.payloadDetails.uuid;
const payloadExpiresOn = state => state.payloadDetails.expiresOn;
const payloadCreated = state => state.payloadDetails.created;
const payloadOrderItems = state => state.payloadDetails.orderItems;
const payloadData = state => state.payloadDetails.data;
const payloadCurrency = state => state.payloadDetails.currency;
const payloadLoading = state => state.payloadDetails.loading;
const payloadErrorMessage = state => state.payloadDetails.errorMessage;
const payloadSuccessMessage = state => state.payloadDetails.successMessage;

const quoteInformation = state => state.quoteDetails.quote;
const quoteSymbol = state => state.quoteDetails.symbol;
const quoteQuoteLiteral = state => state.quoteDetails.quoteLiteral;
const quoteSurcharge = state => state.quoteDetails.surcharge;
const quoteLoading = state => state.quoteDetails.loading;
const quoteErrorMessage = state => state.quoteDetails.errorMessage;
const quoteSuccessMessage = state => state.quoteDetails.successMessage;

const orderNumber = state => state.orderDetails.orderNumber;
const orderData = state => state.orderDetails.data;
const orderLoading = state => state.orderDetails.loading;

const openEndedTokenData = state => state.openEndedTokenDetails.data;
const openEndedTokenClient = state => state.openEndedTokenDetails.client;
const openEndedTokenCurrency = state => state.openEndedTokenDetails.currency;
const openEndedTokenCurrencySymbol = state => state.openEndedTokenDetails.currencySymbol;
const openEndedTokenIsExpired = state => state.openEndedTokenDetails.isExpired;
const openEndedTokenUrl = state => state.openEndedTokenDetails.url;
const openEndedTokenLoading = state => state.openEndedTokenDetails.loading;

const internalQuoteData = state => state.internalQuoteDetails.data;
const internalQuoteLoading = state => state.internalQuoteDetails.loading;
const internalQuoteCurrency = state => state.internalQuoteDetails.data.currency;
const internalQuoteQuoteLiteral = state => state.internalQuoteDetails.data.quoteLiteral;
const internalQuoteOrderLiteral = state => state.internalQuoteDetails.data.order_literal;
const internalQuoteQuote = state => state.internalQuoteDetails.data.quote;
const internalQuoteTotal = state => state.internalQuoteDetails.data.total;
const internalQuoteSymbol = state => state.internalQuoteDetails.data.symbol;

const globalQuotedTickets = state => state.globalQuotedTicketsDetails.globalQuotedTickets;
const globalQuotedTicketsLoading = state => state.globalQuotedTicketsDetails.loading;
const globalQuotedTicketsUpdateCount = state => state.globalQuotedTicketsDetails.count;
const userInformation = state => state.globalQuotedTicketsDetails.userInformation;

export default {
  payloadCustomer,
  payloadBillingAddress,
  payloadOrderToken,
  payloadUuid,
  payloadExpiresOn,
  payloadCreated,
  payloadOrderItems,
  payloadData,
  payloadCurrency,
  payloadLoading,
  payloadErrorMessage,
  payloadSuccessMessage,
  quoteInformation,
  quoteSymbol,
  quoteQuoteLiteral,
  quoteSurcharge,
  quoteLoading,
  quoteErrorMessage,
  quoteSuccessMessage,
  orderNumber,
  orderData,
  orderLoading,
  openEndedTokenData,
  openEndedTokenClient,
  openEndedTokenCurrency,
  openEndedTokenCurrencySymbol,
  openEndedTokenIsExpired,
  openEndedTokenUrl,
  openEndedTokenLoading,
  internalQuoteData,
  internalQuoteLoading,
  internalQuoteCurrency,
  internalQuoteQuoteLiteral,
  internalQuoteOrderLiteral,
  internalQuoteQuote,
  internalQuoteTotal,
  internalQuoteSymbol,
  globalQuotedTickets,
  globalQuotedTicketsLoading,
  globalQuotedTicketsUpdateCount,
  userInformation,
};
